import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import styled from 'styled-components';
import { HintButton, Button } from '@lt/components';

import type { IHintButtonContainer } from './types';

const StyledHintButtonWrapper = styled.span`
  margin-right: 5px;
`;

const onTouchEnd = (e) => {
  e.preventDefault();
  e.stopPropagation();
};

/**
 * @deprecated
 * Использовать Bubble из lt-components
 * @see https://storybook.lvtv.me/?path=/story/bubble--default
 */
const HintButtonContainer: FC<IHintButtonContainer> = ({
  text,
  className,
  dataAttr = 'text-hint',
  position = 'top',
  isMobile = false,
  children,
}) => {
  const hintCls = cn('lt-icons-hint', className);
  const textAttr = {
    [`data-${dataAttr}`]: text,
    [`data-${dataAttr}-at`]: position,
  };

  return children ? (
    <Button
      className={className}
      {...textAttr}
      onClick={isMobile ? onTouchEnd : null}
      functional
    >
      <StyledHintButtonWrapper>
        <HintButton className="lt-icons-hint" as="span" />
      </StyledHintButtonWrapper>
      {children}
    </Button>
  ) : (
    <HintButton
      className={hintCls}
      {...textAttr}
      onClick={isMobile ? onTouchEnd : null}
    />
  );
};

export default HintButtonContainer;
